<template>
    <h1
        :class="[
            `font-extrabold text-transparent text-3xl md:text-4xl bg-clip-text
            bg-gradient-to-r from-${colorScheme}-600 to-${colorScheme}-400 pb-px`
        ]"
    >
        <slot />
    </h1>
</template>

<script>
    import advisory_partner_mixin from '@/mixins/advisory_partner_mixin';

    export default {
        mixins: [
            advisory_partner_mixin,
        ],
    };
</script>
